"use client";

import { createApi } from "@reduxjs/toolkit/query/react";

import baseQuery from "@/libs/shared/api/baseQuery";

const tagTypes = ["Assignments" as const];

export const migrationApi = createApi({
  reducerPath: "migrationApi",
  baseQuery,
  tagTypes,
  endpoints: (builder) => ({
    completeMigration: builder.mutation<void, { token: string }>({
      query: (body) => ({
        url: `/customer/complete-migration`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCompleteMigrationMutation } = migrationApi;
